import { useEffect, useState } from 'react';
import { facilityApi } from '../api';
import { Facility } from '../api_types';

export function useFacility(facilityId?: string, businessId?: string) {
  const [facility, setFacility] = useState<Facility | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!facilityId || !businessId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    facilityApi.getFacility(facilityId, businessId)
      .then(facilityData => {
        setFacility(facilityData);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load facility');
        setLoading(false);
      });
  }, [facilityId, businessId]);

  return { facility, loading, error };
} 